import { useEffect, useState } from 'react';
import { Box, Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useDataProvider, useNotify } from 'react-admin';
import { ClientDataType, MemberSummaryCleintProps } from '../utils/DataTypes';
import { MEMBER_SUMMARY_STRINGS } from '../constants';

const ExceptionClientList = ({
  selectedClient,
  setSelectedClient,
  label = MEMBER_SUMMARY_STRINGS.CLIENT_FILTER.SEARCH_CLIENT,
  disabled = false,
  reportType,
  showExceptionClients = false,
}: MemberSummaryCleintProps) => {
  const [inputValue, setInputValue] = useState('');
  const [clients, setClients] = useState<ClientDataType[]>([]);

  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  useEffect(() => {
    setLoading(true);

    const fetchClients = async () => {
      try {
        const { data } = showExceptionClients
          ? await dataProvider.getList('ReportExceptionClients', {
              pagination: { page: 1, perPage: 5000 },
              sort: { field: 'client_name', order: 'ASC' },
            })
          : await dataProvider.getList('clients', {
              filter: { report_type: reportType },
              pagination: { page: 1, perPage: 5000 },
              sort: { field: 'client_name', order: 'ASC' },
            });

        setClients(data);
      } catch (error) {
        notify('notifications.CLIENT_FILTER.FETCH_ERROR', { type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [reportType, showExceptionClients, dataProvider, notify]);

  const filteredOptions = clients.filter(
    (option) =>
      (option.client_name && option.client_name.toLowerCase().includes(inputValue.toLowerCase())) ||
      (option.client_number && option.client_number.toLowerCase().includes(inputValue.toLowerCase()))
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        options={filteredOptions}
        getOptionLabel={(option) =>
          `${option.client_name}${
            option.client_number ? ` (${option.client_number})` : ` ${MEMBER_SUMMARY_STRINGS.CLIENT_ID_MISSING_LABEL}`
          }`
        }
        isOptionEqualToValue={(option, value) => option.client_number === value.client_number}
        value={selectedClient}
        onChange={(event, newValue) => setSelectedClient(newValue)}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        loading={loading}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            size="small"
            disabled={disabled}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} sx={{ marginRight: 1 }} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default ExceptionClientList;
